import React from "react";
import {
  Typography,
  Select,
  MenuItem,
  Checkbox,
  Chip,
  Box,
} from "@mui/material";

const AudienceSelector = ({ value, onChange }) => {
  const options = ["Women", "Men", "Kids"];
  return (
    <>
      <Typography mt={2} fontWeight={600}>
        Audience
      </Typography>
      <Select
        multiple
        fullWidth
        value={value}
        onChange={onChange}
        renderValue={(selected) => (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {selected.map((val) => (
              <Chip key={val} label={val} />
            ))}
          </Box>
        )}>
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            <Checkbox checked={value.includes(option)} />
            {option}
          </MenuItem>
        ))}
      </Select>
    </>
  );
};

export default AudienceSelector;
